// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"1dc80b54","126":"a4577e18","162":"f41d13ad","171":"042fe8a6","491":"b5a63911"}[chunkId] + ".chunk.js";
};